<app-page-title title="Centre de notifications"></app-page-title>
<div class="container-fluid main">
  <ng-container *ngIf="loading">
    <app-data-loading></app-data-loading>
  </ng-container>
  <ng-container *ngIf="!loading">
    <div *ngIf="notifications.length>0; else noData">
      <div class="main-actions">
        <button type="submit" mat-mini-fab class="white m-2" (click)="onDeleteAll()" appTooltip="{{ 'deleteAll' |
          translate }}"><mat-icon>delete_forever</mat-icon></button>
        <button type="submit" mat-mini-fab class="white m-2" (click)="onReadAll()" appTooltip="{{ 'readAll' |
          translate }}"><mat-icon>checklist_rtl</mat-icon></button>
      </div>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let notif of notifications; let i = index" [expanded]="curNotificationIndex === i"
          (opened)="readNotification(i)" hideToggle>
          <mat-expansion-panel-header [class]="notif.item.read ? '' : 'unread'">
            <mat-panel-title> {{ notif.item.title }}
            </mat-panel-title>
            <mat-panel-description>
              {{ isMobile ? (notif.item.receptionDate | dateFormat) : (notif.item.receptionDate | dateTimeFormat)}}
            </mat-panel-description>
            <span class="mat-expansion-panel-header-icon"><mat-icon>{{ notif.item.read ? 'drafts' : 'mark_email_unread'
                }}</mat-icon></span>
          </mat-expansion-panel-header>
          <div class="content" [innerHtml]="notif.safeContent"></div>
          <mat-action-row>
            <button mat-mini-fab color="primary" (click)="goToLink(i)"
              appTooltip="{{ 'link' | translate }}"><mat-icon>link</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="nextNotification()"
              appTooltip="{{ 'next' | translate }}"><mat-icon>navigate_next</mat-icon></button>
            <button mat-mini-fab color="primary" (click)="onDeleteNotification(i)"
              appTooltip="{{ 'delete' | translate }}"><mat-icon>delete</mat-icon></button>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>
  <mat-paginator *ngIf="notifications.length>0" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons [length]="paging.length"
    (page)="handlePageEvent($event)"></mat-paginator>
</div>

<ng-template #noData>
  <span class="no-content">Vous n'avez aucune notification pour le moment.</span>
</ng-template>